// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ReconciliationFilledSvg from "@ant-design/icons-svg/es/asn/ReconciliationFilled";
import AntdIcon from '../components/AntdIcon';

var ReconciliationFilled = function ReconciliationFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ReconciliationFilledSvg
  }));
};

ReconciliationFilled.displayName = 'ReconciliationFilled';
export default React.forwardRef(ReconciliationFilled);